import React from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import ColorDetail from '../../../components/ColorDetail';
import Detail from './Detail';
import {CardetailsInterface} from '..';
import {getLang, getTranslations} from '../../../translations';

const FuelType = styled.div``;
const Transmission = styled.div``;
const City = styled.div``;
const Highway = styled.div``;
const Exterior = styled.div``;
const Interior = styled.div``;
const Vin = styled.div``;
const StockNumber = styled.div``;
const InventoryDate = styled.div``;

const CarDetailContainer = styled.div`
  background-color: #f9f9f9;
  padding: var(--size-dynamic0100);
`;

const DetailContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: var(--size-dynamic0050);

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0.5rem;
    ${FuelType} {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
    ${Transmission} {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
    ${City} {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }
    ${Highway} {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }
    ${Exterior} {
      grid-column: 3 / 4;
      grid-row: 1 / 2;
    }
    ${Interior} {
      grid-column: 3 / 4;
      grid-row: 2 / 3;
    }
  }
`;

interface CardetailInterface extends CardetailsInterface {}

export default ({vehicle}: React.PropsWithChildren<CardetailInterface>) => {
  const lang = getLang();
  const trans = getTranslations();

  const litres = new Intl.NumberFormat(`${lang}-CA`, {
    style: 'unit',
    unit: 'liter',
    unitDisplay: 'long',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return (
    vehicle && (
      <CarDetailContainer>
        <DetailContainer>
          <FuelType>
            <Detail
              headline={trans.labels.fuel_type}
              copy={
                vehicle?.fuel_economies && vehicle?.fuel_economies.type
                  ? vehicle?.fuel_economies.type
                  : ''
              }
            />
          </FuelType>

          <Transmission>
            <Detail
              headline={trans.labels.transmission}
              copy={vehicle?.transmission?.[lang] as string}
            />
          </Transmission>

          <City>
            <Detail
              headline={trans.labels.city}
              copy={
                vehicle?.fuel_economies && vehicle?.fuel_economies.cityValue
                  ? litres.format(
                      Number(vehicle?.fuel_economies.cityValue)
                    ) + trans.details.details_per100km
                  : ''
              }
            />
          </City>

          <Highway>
            <Detail
              headline={trans.labels.highway}
              copy={
                vehicle?.fuel_economies && vehicle?.fuel_economies.hwyValue
                  ? litres.format(Number(vehicle?.fuel_economies.hwyValue)) +
                    trans.details.details_per100km
                  : ''
              }
            />
          </Highway>

          <Exterior>
            <Detail headline={trans.labels.exterior}>
              {vehicle?.color_exterior &&
                vehicle?.color_exterior.label &&
                vehicle?.color_exterior.value && (
                  <ColorDetail
                    name={
                      vehicle?.color_exterior.label[lang] as string
                    }
                    hex={vehicle?.color_exterior.value}
                  />
                )}
            </Detail>
          </Exterior>

          <Interior>
            <Detail headline={trans.labels.interior}>
              {vehicle?.color_interior &&
                vehicle?.color_interior.label &&
                vehicle?.color_interior.value && (
                  <ColorDetail
                    name={vehicle?.color_interior.label[lang]}
                    hex={vehicle?.color_interior.value}
                  />
                )}
            </Detail>
          </Interior>

          <Vin>
            <Detail headline={trans.labels.vin} copy={vehicle?.vin} />
          </Vin>

          <StockNumber>
            <Detail
              headline={trans.labels.stock_number}
              copy={vehicle?.stock_number}
            />
          </StockNumber>

          <InventoryDate>
            <Detail
              headline={trans.labels.inventory_date}
              copy={vehicle.inventory_date as string}
            />
          </InventoryDate>
        </DetailContainer>
      </CarDetailContainer>
    )
  );
};
